// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 5H21V19H0V5ZM24 9V15H22V9H24Z"}}]};

const BatteryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'battery-filled',
    ref,
    icon: element,
  },
));

BatteryFilledIcon.displayName = 'BatteryFilledIcon';

export default BatteryFilledIcon;
